import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@pg-env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RecipientService {
  private customerApi = environment.customerApiUrl;
  private identityApi = environment.identityApiUrl;
  private clientId = environment.clientId;

  constructor(private http: HttpClient) {
  }

  public addRecipient(recipientModel: any): Observable<any> {
    return this.http.post(`${this.customerApi}/Receipient/add-receipient-bank`, recipientModel);
  }

  public sendPassCode(verificationType): Observable<any> {
    return this.http.get(`${this.identityApi}/account/get-pass-code?verificationType=${verificationType}&ticketType=6`);
  }

  public verificationPassCode(passCode: string, verificationType: string): Observable<any> {
    return this.http.get(
      `${this.identityApi}/account/verification-pass-code?passCode=${passCode}&verificationType=${verificationType}`
    );
  }

  public verificationCodePayment(passCode: string, verificationType: string, actionId: string): Observable<any> {
    return this.http.get(
      `${this.identityApi}/account/verification-pass-code?passCode=${passCode}&verificationType=${verificationType}&actionId=${actionId}`
    );
  }

  public getRecipientList(getRecipientByName): Observable<any> {
    return this.http.post(`${this.customerApi}/receipient/get-receipient-by-name`, getRecipientByName);
  }

  public getUniqueRecipientPerCurrency(currencyCode): Observable<any> {
    return this.http.get(`${this.customerApi}/receipient/get-recipientMandate-by-CurrencyCode/${currencyCode}`);
  }

  public RemoveRecipientMandateTag(recipients): Observable<any> {
    return this.http.post(`${this.customerApi}/Receipient/remove-recipientMandateTag-by-id`, recipients);
  }

  public SetRecipientAsMandate(recipientAndCurrency): Observable<any> {
    return this.http.post(`${this.customerApi}/Receipient/set-recipient-AsMandate`, recipientAndCurrency);
  }

  public getRecipientById(recipient): Observable<any> {
    return this.http.post(`${this.customerApi}/receipient/get-receipient-by-id`, recipient);
  }

  public updateRecipientBanks(recipientBank): Observable<any> {
    return this.http.post(`${this.customerApi}/Receipient/update-receipient-banks`, recipientBank);
  }

  public deleteRecipientBanks(receipient): Observable<any> {
    return this.http.post(`${this.customerApi}/Receipient/delete-receipient-bank`, receipient);
  }

  public validateIban(iban: string): Observable<any> {
    return this.http.get(`${this.customerApi}/banking/validate-iban/${iban}`);
  }

  public validate(param): Observable<any> {
    return this.http.post(`${this.customerApi}/banking/validate`, param);
  }

  public verifySwiftCode(swift: string): Observable<any> {
    return this.http.get(`${this.customerApi}/banking/validate-swift/${swift}`);
  }

  public runProfileCheck(profileCheck: any): Observable<any> {
    return this.http.post(`${this.customerApi}/passfort/run-profile-check`, profileCheck);
  }

  public runInvidualCheck(profileCheck: any): Observable<any> {
    return this.http.post(`${this.customerApi}/passfort/runRecipientPepAndSanctionsCheckAsync`, profileCheck);
  }

  public cleanText(input: any) {
    return input ? input : null;
  }

  public acceptSWIFT(queryString: string): Observable<any> {
    return this.http.get(`${this.customerApi}/banking/accept-swift?${queryString}`);
  }

  public requireTaxId(queryString: string): Observable<any> {
    return this.http.get(`${this.customerApi}/payment/require-tax-id?${queryString}`);
  }

  public getBankingConfig(): Observable<any> {
    return this.http.get(`${this.customerApi}/banking/get-banking-config`);
  }

  public validateRecipientBankModel(recipientBankModel) {
    return this.http.post(`${this.customerApi}/Receipient/validate-recipient-bank-model`, recipientBankModel);
  }
}
